module.exports.validateFormDataOnFormSubmission = function (form) {

    const setCustomValidityMsg = function (formElement) {
        const elementsToUpdate = formElement.type === 'radio' ? document.getElementsByName(formElement.name) : [formElement];

        let areElementsValid = false;
        for (let i = 0; i < elementsToUpdate.length; i++) {
            areElementsValid = areElementsValid || !(elementsToUpdate[i].validity.patternMismatch || elementsToUpdate[i].validity.valueMissing);
        }

        for (let j = 0; j < elementsToUpdate.length; j++) {
            elementsToUpdate[j].setCustomValidity(areElementsValid ? '' : elementsToUpdate[j].title);
        }
    };

    const formElements = form.elements;
    for (let i = 0; i < formElements.length; i++) {
        const formElement = formElements[i];
        setCustomValidityMsg(formElement);
        formElement.addEventListener(formElement.type === 'radio' ? 'click' : 'input', function () {
            setCustomValidityMsg(this);
        })
    }

    const submissionControl = form.querySelector('input[type=submit], input[type=button].btn-submit');
    submissionControl.addEventListener('click', function () {
        form.classList.add('submitted');
    });

};
